module.exports = __webpack_public_path__ + "static/media/998791.97219f8a.png";